module.exports = __webpack_public_path__ + "img/Illustration-11.59a452be.png";